import API from './jsonapi-constants'

export const CONSTANTS = {
  ID: {
    PAYMENT: 'payment',
    DELIVERY: 'delivery',
  },
  CODE: {
    PAYMENT: ['short_payment', 'long_payment'],
    DELIVERY: ['delivery_standard', 'delivery_express'],
  },
  TEXT_TYPE: {
    NAME: 'name', // Todo: refactor use API_CONSTANTS.AIMEOS.TEXT.TYPE.NAME
  },
  ATTRIBUTE: {
    CODE: 'service.code',
    DATEEND: 'service.dateend',
    DATESTART: 'service.datestart',
    ID: 'service.id',
    LABEL: 'service.label',
    POSITION: 'service.position',
    PROVIDER: 'service.provider',
    STATUS: 'service.status',
    TYPE: 'service.type',
    PRICE: {
      COSTS: 'price.costs',
      CURRENCYID: 'price.currencyid',
      DOMAIN: 'price.domain',
      ID: 'price.id',
      LABEL: 'price.label',
      QUANTITY: 'price.quantity',
      REBATE: 'price.rebate',
      STATUS: 'price.status',
      TAXFLAG: 'price.taxflag',
      TAXRATE: 'price.taxrate',
      TAXRATES: 'price.taxrates',
      TAXVALUE: 'price.taxvalue',
      TYPE: 'price.type',
      VALUE: 'price.value',
    },
  },
}

export const PATHS = {
  CRDATE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CRDATE],
  CODE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CODE],
  DATEEND: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.DATEEND],
  DATESTART: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.DATESTART],
  ID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ID],
  LABEL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LABEL],
  POSITION: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.POSITION],
  PROVIDER: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PROVIDER],
  STATUS: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.STATUS],
  TYPE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TYPE],
  PRICE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRICE],
  PRICE_COSTS: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRICE, CONSTANTS.ATTRIBUTE.PRICE.COSTS],
  PRICE_CURRENCYID: [
    API.ATTRIBUTES,
    CONSTANTS.ATTRIBUTE.PRICE,
    CONSTANTS.ATTRIBUTE.PRICE.CURRENCYID,
  ],
  PRICE_DOMAIN: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRICE, CONSTANTS.ATTRIBUTE.PRICE.DOMAIN],
  PRICE_ID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRICE, CONSTANTS.ATTRIBUTE.PRICE.ID],
  PRICE_LABEL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRICE, CONSTANTS.ATTRIBUTE.PRICE.LABEL],
  PRICE_QUANTITY: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRICE, CONSTANTS.ATTRIBUTE.PRICE.QUANTITY],
  PRICE_REBATE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRICE, CONSTANTS.ATTRIBUTE.PRICE.REBATE],
  PRICE_STATUS: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRICE, CONSTANTS.ATTRIBUTE.PRICE.STATUS],
  PRICE_TAXFLAG: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRICE, CONSTANTS.ATTRIBUTE.PRICE.TAXFLAG],
  PRICE_TAXRATE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRICE, CONSTANTS.ATTRIBUTE.PRICE.TAXRATE],
  PRICE_TAXRATES: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRICE, CONSTANTS.ATTRIBUTE.PRICE.TAXRATES],
  PRICE_TAXVALUE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRICE, CONSTANTS.ATTRIBUTE.PRICE.TAXVALUE],
  PRICE_TYPE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRICE, CONSTANTS.ATTRIBUTE.PRICE.TYPE],
  PRICE_VALUE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRICE, CONSTANTS.ATTRIBUTE.PRICE.VALUE],
}

export default {
  ...CONSTANTS,
  PATHS,
}
